import styled from "styled-components";

export default styled.div`
  position: relative;
  display: flex;
  height: 230px;
  background: #333;
  width: 720px;
  border: 15px solid #333;
  border-top: none;
`;
